var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoRegistro4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icono-registro-4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono-registro-4",
    clipPath: "url(#clip-icono-registro-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_local_florist_24px",
    d: "M16.5,32.5A13.5,13.5,0,0,0,30,19,13.5,13.5,0,0,0,16.5,32.5ZM6.9,14.875a3.754,3.754,0,0,0,5.88,3.09l-.03.285a3.75,3.75,0,0,0,7.5,0l-.03-.285a3.7,3.7,0,0,0,2.13.66,3.741,3.741,0,0,0,1.6-7.125A3.745,3.745,0,1,0,20.22,5.035l.03-.285a3.75,3.75,0,0,0-7.5,0l.03.285a3.7,3.7,0,0,0-2.13-.66A3.741,3.741,0,0,0,9.045,11.5,3.737,3.737,0,0,0,6.9,14.875ZM16.5,7.75a3.75,3.75,0,1,1-3.75,3.75A3.751,3.751,0,0,1,16.5,7.75ZM3,19A13.5,13.5,0,0,0,16.5,32.5,13.5,13.5,0,0,0,3,19Z",
    transform: "translate(3.5 3.25)",
    fill: "#225b2a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRegistro4);
export default __webpack_public_path__ + "static/media/icono-registro-4.f4f494ae0e1a2df3b27169e7df64f303.svg";
export { ForwardRef as ReactComponent };